import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ActiveTaskCommand } from './active-task-command';
import {
  InsertTaskCommand,
  TaskIdAttibute,
  TaskTypeAttibute,
  TaskActiveAttibute,
} from './insert-task-command';
import { RemoveTaskCommand } from './remove-task-command';

export class TaskEditing extends Plugin {
  static get pluginName(): string {
    return 'TaskEditing';
  }

  init(): void {
    // Allow task attribute on text nodes.
    const { editor } = this;

    editor.model.schema.extend('$text', {
      allowAttributes: [TaskIdAttibute, TaskTypeAttibute, TaskActiveAttibute],
    });
    editor.conversion.attributeToAttribute({
      model: TaskIdAttibute,
      view: `data-${TaskIdAttibute}`,
    });
    editor.conversion.attributeToAttribute({
      model: TaskTypeAttibute,
      view: `data-${TaskTypeAttibute}`,
    });
    editor.conversion.attributeToAttribute({
      model: TaskActiveAttibute,
      view: `data-${TaskActiveAttibute}`,
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: TaskIdAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${TaskIdAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: TaskTypeAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${TaskTypeAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: TaskActiveAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${TaskActiveAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });

    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${TaskIdAttibute}`,
      },
      model: {
        key: TaskIdAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(`data-${TaskIdAttibute}`);

          return value;
        },
      },
    });
    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${TaskTypeAttibute}`,
      },
      model: {
        key: TaskTypeAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(`data-${TaskTypeAttibute}`);

          return value;
        },
      },
    });
    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${TaskActiveAttibute}`,
      },
      model: {
        key: TaskActiveAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(`data-${TaskActiveAttibute}`);

          return value;
        },
      },
    });

    editor.commands.add(
      'insertTaskCommand',
      new InsertTaskCommand(this.editor),
    );
    editor.commands.add(
      'removeTaskCommand',
      new RemoveTaskCommand(this.editor),
    );
    editor.commands.add(
      'activeTaskCommand',
      new ActiveTaskCommand(this.editor),
    );
  }
}
